<div class="main-content">
  <div class="container-fluid">
    <div class="header-actions">
      <h4 class="card-title">Dashboard</h4>
      <fh-refresh-button [onRefresh]="refreshDashboard" />
    </div>

    <!--
      One market at a time: amounts are in the market's own currency, so SG and
      US are never added together.
    -->
    <div class="market-toggle" role="group" aria-label="Market">
      <span class="market-toggle-label">Market</span>
      @for (iso2 of markets; track iso2) {
        <label class="market-option">
          <input
            type="checkbox"
            [checked]="market === iso2"
            (change)="selectMarket(iso2, $event)"
          />
          <span class="market-swatch" [style.background]="marketSwatch(iso2)"></span>
          {{ iso2 }}
        </label>
      }
      <span class="market-currency">Amounts in {{ currency }}</span>
    </div>

    @if (loadError) {
      <div class="alert alert-danger">{{ loadError }}</div>
    }

    <!-- Same layout as the admin dashboard's order charts: one per row. -->
    @for (chart of charts; track chart.key) {
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">{{ chart.title }}</h4>
              <p class="card-category">{{ chart.subtitle }}</p>
            </div>
            <div class="card-body" style="height: 400px;">
              <canvas baseChart
                [type]="barChartType"
                [data]="chart.data"
                [options]="chart.options">
              </canvas>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>
